import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { AlertTriangle, CheckCircle2 } from "@/components/icons"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function DemoParserTips() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-parser.getting-started.tips_demo" })
  const list = (key: string) => ensureArray<string>(t(key, { returnObjects: true }))

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Card className="border-success bg-success/15 text-foreground">
        <CardHeader className="pb-3">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="text-success h-5 w-5" />
            <h3 className="text-success text-base font-bold">{t("dos_title", "Do this")}</h3>
          </div>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2.5">
            {list("dos_items").map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm">
                <CheckCircle2 className="text-success mt-0.5 h-3.5 w-3.5 shrink-0" />
                <span>{parse(item)}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      <Card className="border-warning-ink/40 bg-warning/30">
        <CardHeader className="pb-3">
          <div className="flex items-center gap-2">
            <AlertTriangle className="text-warning-ink h-5 w-5" />
            <h3 className="text-warning-ink text-base font-bold">
              {t("gotchas_title", "Watch out for")}
            </h3>
          </div>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2.5">
            {list("gotchas_items").map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm">
                <AlertTriangle className="text-warning-ink mt-0.5 h-3.5 w-3.5 shrink-0" />
                <span>{parse(item)}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  )
}
